
const TEST_STATES = {
    Unknown: 0,
    PendingCreation: 5,
    Created: 10,
    PendingProctorData: 102,
    PendingUserData: 105,
    CodeExpired: 197,

    PendingStart: 200,
    Started: 205,
    InProgress: 210,

    Submitted: 301,
    PendingAutoGrading: 310,
    PendingManualGrading: 311,

    PendingBilling: 601,
    Complete: 800
};

const TEST_INSTANCE_STATUS = {
    Unknown: 0,
    PendingStart: 5,
    PendingTest: 10,
    PendingGrading: 20,
    GradingInProgress: 25,
    Completed: 30,
    UnableToGrade: 250,
    Deleted: 255
};

const TEST_SCORE_TYPES = {
    Applicant: 1, Company: 2, Overall: 3
};
const LOG_SEVERITY = {
    INFO: 10, DEBUG: 20, WARNING: 30, ERROR: 40, EXCEPTION: 50, CRITICAL: 60
};

const ROLE_PERMS = {
    CreateSite: 1,
    EditSite: 2,
    DeleteSite: 3,
    CreateUser: 10,
    EditUser: 11,
    DeleteUser: 12,
    AssignUserRoles: 13,
    AssignUserSites: 14,
    EditTestTypes: 20,

    EditRoles: 30,
    AddRole: 31,
    DeleteRole: 32,

    EditCompany: 50,

    EditJobs: 60,
    AddJob: 61,
    ApproveJobDescription: 62,
    SetJobDescription: 63,
    DeleteJob: 64,

    EditTestRequest: 70,
    DeleteTest: 82,
    TestEdit: 83,
    MatchView: 85,

    AnonTestTaker: 84,
    ReportView: 90,

    DashboardViewable: 140,
    CompanyMenuCompany: 150,
    CompanyMenuSites: 151,
    CompanyMenuUsers: 152,
    CompanyMenuRoles: 153,
    CompanyMenuJobs: 154,
    CompanyMenuImages: 155,
    CompanyMenuTestTypes: 156,
    CompanyMenuTestRecents: 157,
    CompanyMenuTestRequest: 158,
    CompanyMenuTestOrgChart: 159,
    CompanyMenuBilling: 160,
    CompanyMenuDashboard: 161,
    CompanyMenuCompatibility: 162,
    CompanyCulture: 163,
    CompanyMenuJobMatch: 164,
    ApproveInvoice: 165,
    Translator: 166,
    CompanyMenuHelp: 167,
    CompanyMenuDepartments: 168,
    CompanyMenuReports: 169,
    KpsiAccess: 170,

    CompanyAdmin: 253,
    SystemAdmin: 254
};

const JOB_DESCRIPTION_STATE = {
    Created: 0,
    PendingDescription: 2,
    PendingDescriptionEdit: 3,
    PendingDescriptionAcceptance: 4,
    DescriptionApproved: 10,
    Archived: 250,
    Deleted: 255
}

const JOB_STATE = {
    PendingDescription: 1,
    PendingEF: 10,
    PendingAlgo: 20,
    Active: 30,
    Archived: 250,
    Deleted: 255
};

const ENTITY_ACTION = {
    Create: 1,
    Rename: 2,
    Modify: 3,
    Delete: 4,
    Move: 5,
    Retrieve: 6,
    Configure: 7,
    Upload: 8,
    Download: 9,
    Send: 10,
    Receive: 11,
    Process: 12,
    Access: 13,
    Copy: 14,
    Logging: 20,
    Login: 50,
    Logout: 51,
    ChangePermissions: 52,
    Error: 255,
};

const ENTITY_TYPE = {
    Test: 1,
    Response: 2,
    Section: 3,
    TestType: 4,
    User: 5,
    Company: 6,
    Email: 7,
    Sms: 8,
    Role: 9,
    Site: 10,
    SiteRole: 11,
    CompanyTestType: 12,
    TestStatus: 13,
    Blob: 14,
    TestContent: 15,
    Job: 16,
    JobEmployability: 17,
    AuditLog: 18,
    Account: 19,
    TestScore: 20,
    JobDescription: 21,
    Error: 255
};

const CONTENT_TYPE = {
    RequestFormInstructions: 4,
    StartTestButton: 5,
    RecentsInstructions: 6,
    RequestTableTitle: 7,
    SecondaryInstructions: 8,
    RequestModalTitle: 21,
    LanguagePrompt: 22,
    RestartPage: 23,
    CttCodeTimedOut: 24,
    CttCodeEmbargoed: 25,
};

const CONTENT_FORMAT = {
    Text: 0,
    HTML: 1,
    JSON: 2,
};

const INVOICE_STATUS = {
    Paid: 1,
    Unpaid: 2,
    Overdue: 3,
    PartiallyPaid: 4,
    Accruing: 10,
    PendingApproval: 11,
    Approved: 12,
    Deleted: 254
}

const PAYMENT_METHOD = {
    CreditCard: 1,
    BankTransfer: 2,
    Cash: 3,
    Check: 4,
    Other: 5
}

const PAYMENT_STATUS = {
    Completed: 1,
    Pending: 2,
    Failed: 3,
    Refunded: 4,
    PartiallyPaid: 5
}

const ADMIN_USER_TASK_STATUS = {
    Pending: 1,
    Completed: 2,
    Ignored: 3,
};

const TEST_RESTART_MODE = {
    NotRestartable: 0,
    SectionRestart: 1,
    AnswerRestart: 2,
};

function resumesExistingAttempt(value) {
    if (value === true) return true;
    const mode = Number(value);
    return mode === TEST_RESTART_MODE.SectionRestart || mode === TEST_RESTART_MODE.AnswerRestart;
}

function restoresSectionAnswers(value) {
    return Number(value) === TEST_RESTART_MODE.AnswerRestart;
}

function getTestRestartModeLabel(value) {
    switch (Number(value)) {
        case TEST_RESTART_MODE.SectionRestart:
            return "Section restart";
        case TEST_RESTART_MODE.AnswerRestart:
            return "Answer restart";
        default:
            return "Not restartable";
    }
}

const TEST_EVAL_COMPARISON = {
    None: 0,
    Culture: 1,
    EF: 2,
    BE_SOURCE: 20
}
const BLOB_TYPE = {
    Unknown: 0,
    CompanyImage: 1,
    JobDescription: 2
}


/** User-facing label for TEST_EVAL_COMPARISON. BE = Behavioral Expectations (consumer); BE_SOURCE = BE Source platform. */
function getTestEvalComparisonLabel(evalComparison) {
    const evalValue = parseInt(evalComparison, 10) || 0;
    switch (evalValue) {
        case TEST_EVAL_COMPARISON.Culture:
            return "Culture";
        case TEST_EVAL_COMPARISON.EF:
            return "BE";
        case TEST_EVAL_COMPARISON.BE_SOURCE:
            return "BE Source";
        case TEST_EVAL_COMPARISON.None:
        default:
            return "";
    }
}

const Enums = {
    TEST_STATES,
    TEST_INSTANCE_STATUS,
    TEST_SCORE_TYPES,
    LOG_SEVERITY,
    ROLE_PERMS,
    JOB_STATE,
    ENTITY_ACTION,
    ENTITY_TYPE,
    JOB_DESCRIPTION_STATE,
    INVOICE_STATUS,
    ADMIN_USER_TASK_STATUS,
    PAYMENT_METHOD,
    PAYMENT_STATUS,
    TEST_EVAL_COMPARISON,
    getTestEvalComparisonLabel,
    TEST_RESTART_MODE,
    resumesExistingAttempt,
    restoresSectionAnswers,
    getTestRestartModeLabel,
    CONTENT_TYPE,
    CONTENT_FORMAT,
    BLOB_TYPE
}




export default Enums;

